var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38959 2.54102H11.8886M2.89062 4.7905H16.3875M14.8879 4.7905L14.362 12.6781C14.2831 13.8616 14.2437 14.4533 13.9881 14.9019C13.7631 15.2969 13.4236 15.6145 13.0145 15.8127C12.5499 16.0379 11.9569 16.0379 10.7708 16.0379H8.50732C7.32128 16.0379 6.72826 16.0379 6.2636 15.8127C5.85451 15.6145 5.51509 15.2969 5.29006 14.9019C5.03446 14.4533 4.99502 13.8616 4.91612 12.6781L4.39028 4.7905",
    stroke: "black",
    strokeWidth: 1.68711,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.1800f9e430c9d4576a1c8f9f06d64bcf.svg";
export { ForwardRef as ReactComponent };